import { DatePicker } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomHeaderTitle from "../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../components/HeaderBread";
import Logs from "../../components/Logs";
import SearchField from "../../components/SearchField";
import CustomizedTable from "../../components/UI/CustomizedTable";
import RoutesFilter from "../../components/UI/RoutesFilter";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import Layout from "../../Layout";
import { getUserAPIlogData, getUserlogData } from "../../utils/ApiCalls/Logs";
import JSONPopup from "./JSOnPopup";
import SwitchBar from "../../components/Pages/SwitchBar";
import OldLogs from "../../components/Logs/olgLogs";
const UserLogs = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "User logs",
      route: "/website/cms/user-logs",
    },
  ];
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [active, setActive] = useState("current");
  const [routes, setRoutes] = useState([]);
  const [logDate, setLogDate] = useState();
  const [search, setSearch] = useState("");
  const [currentRoute, setCurrentRoute] = useState("");
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const columns = [
    {
      title: "Sl",
      width: 10,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (position, record, index) => (page - 1) * pageSize + index + 1,
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      width: 50,
    },
    {
      title: "Method",
      dataIndex: "method",
      key: "method",
      width: 100,
    },
    {
      title: "Request body",
      dataIndex: "request_body",
      key: "request_body",
      width: 100,
      render: (item) => <JSONPopup json={item} />,
    },
    {
      title: "Response body",
      dataIndex: "response_body",
      key: "response_body",
      width: 100,
      render: (item) => <JSONPopup json={item} />,
    },
    {
      title: "Response time",
      dataIndex: "response_time",
      key: "response_time",
      width: 100,
      render: (item) => item + "s",
    },
    {
      title: "IP address",
      dataIndex: "ip_address",
      key: "ip_address",
      width: 100,
    },
    {
      title: "Created at",
      dataIndex: "created_at",
      key: "created_at",
      width: 200,
      render: (item) => moment.utc(item).format("DD-MM-YYYY hh:mm a"),
    },
  ];
  useEffect(() => {
    getData(page);
  }, [page, pageSize, search, logDate]);

  useEffect(() => {
    getURl();
  }, []);
  const getData = async (value) => {
    let args = { search: search, page: value, logDate, limit: pageSize };
    if (currentRoute) {
      args.url = currentRoute;
    }

    let data = await getUserlogData(args);
    if (data.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    } else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
  };

  const getURl = async () => {
    let args = { page: 1, limit: 1000, isLog: 1 };
    let data = await getUserAPIlogData(args);
    if (data.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    } else if (data.data) {
      setRoutes(data.data);
    }
  };
  return (
    <Layout type={"read_per"} module_data={"User logs"}>
      <CustomHeaderTitle title={"User logs"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"User logs"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <SwitchBar
            tabs={[
              { title: "Current logs", value: "current" },
              { value: "old", title: "Old logs" },
            ]}
            activeTab={active}
            setActiveTab={setActive}
          />
          <div className="container-fluid">
            {active === "current" && (
              <div className="card">
                <div className="card-header two_item">
                  <DatePicker
                    style={{
                      width: "150px",
                    }}
                    placeholder="Date"
                    label="Date"
                    onChange={(date, dateString) => {
                      setLogDate(dateString);
                      setPage(1);
                    }}
                    disabledDate={(current) => {
                      const today = dayjs().endOf("day");
                      const startOfMonth = dayjs().startOf("month");
                      // Disable dates before the start of this month or after today
                      return (
                        current && (current < startOfMonth || current > today)
                      );
                    }}
                  />
                  <div className="two_item">
                    <RoutesFilter
                      width={"400px"}
                      data={routes}
                      getData={getData}
                      currentRoute={currentRoute}
                      setCurrentRoute={setCurrentRoute}
                      setPage={setPage}
                    />
                  </div>
                </div>
                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div style={{ maxWidth: 200 }}>
                        <SearchField
                          value={search}
                          SearchValue={() => {
                            setPage(1);
                          }}
                          setValue={(e) => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <CustomizedTable
                      setRows={setRows}
                      setPageSize={setPageSize}
                      setPage={setPage}
                      pageSize={pageSize}
                      page={page}
                      count={count}
                      columns={columns}
                      rows={rows}
                      title={"User logs"}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {active === "old" && (
          <OldLogs
            type={"Promo_Index"}
            slug={"/website/cms/packages/edit/"}
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};

export default UserLogs;
